import React, { useState } from 'react';
import CustomTable from 'ui-components/CustomTable';
import { B400 } from 'ui-components/CustomButton';
import { Primary } from 'ui-components/Buttons';
import { Add, Mail, MailOutline, MailOutlined, MailOutlineRounded, PersonAddAlt, ThumbUp, PublishedWithChanges, CallReceived, PersonRemove, DeleteOutlineRounded, EditOutlined, UpdateOutlined, Upload, GetAppOutlined, Done, DoneRounded, Update, Description, DescriptionOutlined, Close, DoneAll, Edit } from '@mui/icons-material';
import { ReactComponent as MoreOptionsIcon } from "assets/rounds_icons/more_solid_icon.svg";
import ModalComponent from 'ui-components/ModalComponent';
import { ReactComponent as RoundInvestmentIcon } from "assets/rounds_icons/round_investor_icon.svg"
import { Box, Button, Card, Dialog, Grid, Menu, MenuItem, Paper, Skeleton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import CustomTabs from 'ui-components/CustomTabs';
import { makeStyles } from '@mui/styles';
import { TabContext } from '@mui/lab';
// import InviteInvestorPopup from './popups/InviteInvestorPopup';
// import AddInvestmentPopup from './popups/AddInvestmentPopup';
// import AddInvestorPopup from './popups/AddInvestorPopup';
// import MoveToInProgressPopup from './popups/MoveToInProgressPopup';
// import DeleteConfirmationDialog from 'ui-components/popups/ConfirmationPopup';
import { useNavigate, useParams } from 'react-router-dom';
import AsyncTableListing from 'ui-components/AsyncTableListing';
// import InvestorMovePopup from 'ui-components/popups/ConfirmationPopup';
import placeHolderImage from "assets/no_data_images/no_data_feedbacks_views.svg"
import { hasPermission } from 'utils/index';
import { useSelector } from 'react-redux';
import { ChangePipelineInvestorStatus, FetchPipelineInvestors } from 'api/investors';
import { useToast } from 'context/ToastContext';
import Cookies from 'js-cookie';

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        "&": {
            padding: "3rem"
        }
        // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
    }
    //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
    //         display: 'none !important',
    //         transition: 'all 1s ease'
    //     },
    // }
}));

function generateEmail(name) {
    return `${name.toLowerCase().replace(" ", ".")}@example.com`;
}

const CardHeader = ({ title, data: CardHeader, action = () => { } }) => {
    return <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} p={"0.5rem 1rem"}>
        <Typography fontWeight={700} fontSize={"1.25rem"}>
            {title}
        </Typography>
    </Box>
}


const Pipelines = ({ currency, round_id, inRound = false }) => {
    const navigate = useNavigate();
    const theme = useTheme()
    const classes = useStyles();
    const { addToast } = useToast();
    const [value, setValue] = React.useState("invited");
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const startup_id = Cookies.get("startup_id") || null;
    // const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
    const [openInvitePopup, setOpenInvitePopup] = React.useState(false);
    const [openBankDetailsPopup, setOpenBankDetailsPopup] = React.useState(false);
    const [currentRow, setCurrentRow] = React.useState(null);
    // console.log(userPermissions,"userPermissions")

    const handleInvitePopupOpen = () => {
        setOpenInvitePopup(true);
    }

    const handleInvitePopupClose = () => {
        setOpenInvitePopup(false);
    }

    const handleInviteInvestor = () => {
        handleInvitePopupClose()
    }

    const handleBankDetailsPopupOpen = () => {
        setOpenBankDetailsPopup(true)
    }

    const handleBankDetailsPopupClose = () => {
        setOpenBankDetailsPopup(false)
    }

    const handleSubmitBankDetails = () => {
        handleBankDetailsPopupClose()
    }

    const [openAddInvestorModal, setOpenAddInvestorModal] = React.useState(false);

    const handleAddInvestorClose = (row) => {
        setCurrentRow(null)
        setOpenAddInvestorModal(false);
    }
    const handleAddInvestorSubmit = () => {
        setOpenAddInvestorModal(false)
        setCurrentRow(null)
    }

    const [openMoveToInProgressModal, setOpenMoveToInProgressModal] = React.useState(false);

    const handleMoveToInProgressOpen = (row) => {
        setCurrentRow(row)
        setOpenMoveToInProgressModal(true);
    }
    const handleMoveToInProgressClose = (row) => {
        setCurrentRow(null)
        setOpenMoveToInProgressModal(false);
    }
    const handleMoveToInProgressSubmit = () => {
        setOpenAddInvestorModal(false)
        setCurrentRow(null)
    }

    const showRoundName = inRound ? [] : [{ Header: 'Round Name', accessor: 'round_name', minWidth: 150, align: 'center' },]

    const InvitedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
        ...showRoundName,
        { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        { Header: 'Source', accessor: 'source', minWidth: 150, align: 'center', status: true },
        { Header: 'Date', accessor: 'invited_date', minWidth: 150, align: 'center' },
        // { Header: 'Status', accessor: 'invited_status', minWidth: 100, align: 'center' },
        // { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // move to interested and move to rejected
    ];

    const InterestedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
        ...showRoundName,
        // { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        // { Header: 'Source', accessor: 'source', minWidth: 150, align: 'center', status: true },
        { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: "formatted_interested_amount_date", hideDate: true },
        { Header: 'Date', accessor: 'interested_shown_date', minWidth: 150, align: 'center' },
        // { Header: 'Status', accessor: 'invited_status', minWidth: 100, align: 'center' },
        // { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // move to rejected 
    ];

    const InProgressColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
        ...showRoundName,
        // { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        // { Header: 'Source', accessor: 'source', minWidth: 150, align: 'center', status: true },
        { Header: 'Interested Amount', accessor: 'formatted_interested_amount', minWidth: 150, align: 'center', tooltip: "formatted_interested_amount_date", hideDate: true },
        { Header: 'Allocated Amount', accessor: 'formatted_allocated_amount', minWidth: 150, align: 'center', tooltip: "formatted_interested_amount_date", hideDate: true },
        { Header: 'Lead Investor', accessor: 'lead_investor', minWidth: 150, align: 'center', toggle: true, disabled: true },
        { Header: 'KYC', accessor: 'kyc', minWidth: 100, align: 'center', toggle: true, disabled: true },
        { Header: 'Agreements Signed', accessor: 'agreement_signed', minWidth: 180, align: 'center', toggle: true, disabled: true },
        { Header: 'Call for Money', accessor: 'call_for_money', minWidth: 150, align: 'center', toggle: true, disabled: true },
        { Header: 'Fund Received', accessor: 'fund_received', minWidth: 150, align: 'center', toggle: true, disabled: true },
        { Header: 'Date', accessor: 'in_progress_date', minWidth: 150, align: 'center' },
        // { Header: 'Status', accessor: 'invited_status', minWidth: 100, align: 'center' },
        // { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // move to rejected 
    ];
    // { Header: 'Actions', accessor: 'actions', minWidth: 100 }, // move to interested and rejected "with comments" interested amount

    const RejectedColumns = [
        { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start', fixed: true },
        // { Header: 'Type', accessor: 'type', minWidth: 150, align: 'center', status: true }, // received or sent
        // { Header: 'Source', accessor: 'source', minWidth: 150, align: 'center', status: true },
        { Header: 'Date', accessor: 'investor_rejected_date', minWidth: 150, align: 'end' },
        // { Header: 'Status', accessor: 'invited_status', minWidth: 100, align: 'center' },
        // { Header: 'Actions', accessor: 'actions', minWidth: 100, align: 'end' }, // move to interested
    ];


    const columns = React.useMemo(
        () =>
            //      [
            //     { Header: 'Name', accessor: 'name', minWidth: 150, align: 'start' },
            //     { Header: 'Interested Amount', accessor: 'amountCommitted', minWidth: 100, align: 'center' },
            //     { Header: 'Allocated Amount', accessor: 'amountReceived', minWidth: 100, align: 'center' },
            //     { Header: 'Received Amount', accessor: 'callForMoney', minWidth: 100, align: 'center' },
            //     // { Header: 'Call for Money', accessor: 'callForMoney', minWidth: 100, align: 'center' },
            //     { Header: 'Price per Share', accessor: 'drawdown', minWidth: 100, align: 'center' },
            //     // { Header: 'Drawdown %', accessor: 'drawdown', minWidth: 150 },
            //     // { Header: 'Share %', accessor: 'share', minWidth: 150 },
            //     { Header: 'No. of Shares', accessor: 'units', minWidth: 100, align: 'center' },
            //     { Header: 'Status', accessor: 'status', minWidth: 100, align: 'center' },
            //     { Header: 'Actions', accessor: 'actions', minWidth: 100 },
            // ]
            value === 'invited' ? InvitedColumns : value === 'rejected' ? RejectedColumns : value === 'in-progress' ? InProgressColumns : InterestedColumns
        ,
        [value]
    );

    // const { id: round_id } = useParams();
    const [page, setPage] = React.useState(1);
    const [limit, setLimit] = React.useState(10);
    const [sort, setSort] = React.useState(-1);
    const [search, setSearch] = React.useState("");
    const [searchStatus, setSearchStatus] = React.useState(false);
    const [reset, setReset] = React.useState(false);
    // const { data: transformedData, refetch: refetchListing, isLoading: isLoadingPipelineInvestors } = FetchPipelineInvestors({ id: startup_id, value, page, limit, sort })
    const { mutateAsync: fetchPipelineInvestorsAsync, isLoading: isLoadingPipelineInvestors, status: fetchPipelineInvestorsStatus, error: fetchPipelineInvestorsError } = FetchPipelineInvestors();
    // console.log(transformedData, "transformedDatatransformedData")
    const [transformedData, setTransformedData] = React.useState(null);
    const [count, setCount] = React.useState(null);
    const refetchListing = () => {
        // Get the _id for each based on the selected value

        startup_id && fetchPipelineInvestorsAsync(
            {
                page: page,
                limit: limit,
                sort: sort,
                value: value,
                startup_id: startup_id,
                search: search,
                ...(round_id && inRound && { startup_round_id: [round_id] })
                // startup_round_id: []
            },
            {
                onSuccess: (res) => {
                    if (res.data.data) {
                        setTransformedData(res.data?.data?.length > 0 ? res.data?.data?.map(item => {
                            // console.log(item, "item")
                            // console.log(item,"item")
                            const pipeline_item = {
                                ...item,
                                ...item?.pipeline,
                                source: item?.pipeline?.backrr_investor ? "Backrr" : "Self",
                                investor_name: item?.name,
                                organization_name: item?.organization_name,
                                name: item?.investor_type ? String(item?.investor_type)?.toLowerCase()?.includes("angel") ? item?.name : item?.organization_name : item?.name,
                                image: item?.profile_picture,
                                interested_amount_value: <Box sx={{
                                    display: 'grid', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                }}>
                                    {/* {item?.status != "Invited" && item?.interested_amount_value != "" && item?.interested_amount_value && item?.interested_amount_value != null && item?.interested_amount_value != "0" && String(item?.interested_amount_value)?.trim()?.length !== 0 ? */}
                                        <Box>
                                            <Typography>
                                                {item?.interested_amount_value_ref ? item?.interested_amount_value_ref : "-"}
                                            </Typography>
                                        </Box>
                                        
                                        {/* <Box onClick={() => {
                                            setOpenAddInvestorModal(true);
                                            setCurrentRow(item)
                                        }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{
                                            textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor:
                                                "#3538CD"
                                            ,
                                            cursor: "pointer"
                                        }}>
                                            <Add style={{
                                                width: 20, height: 20, color:
                                                    "#3538CD"
                                            }} />
                                            <Typography fontSize={"0.9rem"} color={
                                                "#3538CD"
                                            }> Add </Typography>
                                        </Box>
                                    } */}
                                </Box>,
                                formatted_allocated_amount: <Box sx={{
                                    display: 'grid', alignItems: 'center', color: theme.palette.customColors.g500, fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px'
                                }}>
                                    {/* {item?.status != "Invited" && item?.pipeline?.formatted_allocated_amount && item?.pipeline?.formatted_allocated_amount != "" && item?.pipeline?.formatted_allocated_amount != null && String(item?.pipeline?.formatted_allocated_amount)?.trim()?.length !== 0 ? */}
                                        <Box>
                                            {/* <Tooltip title={item["interested_date"]}> */}
                                            <Typography sx={{ color: "#40454d", fontSize: "14px", fontWeight: 500, lineHeight: '20px', gap: '12px' }}>
                                                {item?.pipeline?.formatted_allocated_amount ? item?.pipeline?.formatted_allocated_amount : "-"}
                                            </Typography>
                                            {/* {!cell.column.hideDate && <Typography fontSize={"0.7rem"}>
                                                    {item?.date}
                                                </Typography>} */}
                                            {/* </Tooltip>  */}
                                        </Box>
                                        
                                        {/* <Box onClick={() => {
                                            setOpenMoveToInProgressModal(true);
                                            setCurrentRow({ ...item, ...item?.pipeline, investor_name: item?.name })
                                        }} display={"flex"} alignItems={"center"} justifyContent={"center"} sx={{
                                            textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor:
                                                // hasPermission("funding_rounds", "edit", userPermissions)
                                                // ? 
                                                "#3538CD"
                                            // : "rgba(0, 0, 0, 0.26)", cursor: 'pointer'
                                            ,
                                            cursor: "pointer"
                                        }}>
                                            <Add style={{
                                                width: 20, height: 20, color:
                                                    // hasPermission("funding_rounds", "edit", userPermissions)
                                                    // ? 
                                                    "#3538CD"
                                                // : "rgba(0, 0, 0, 0.26)"
                                            }} />
                                            <Typography fontSize={"0.9rem"} color={
                                                // hasPermission("funding_rounds", "edit", userPermissions)
                                                // ? 
                                                "#3538CD"
                                                // :
                                                // "rgba(0, 0, 0, 0.26)"
                                            }> Add </Typography>
                                        </Box>
                                    } */}
                                </Box>
                            }
                            // delete pipeline_item?.pipeline;
                            return (pipeline_item)
                        })
                            : []);
                    }
                    else {
                        setTransformedData([])
                    }
                    setCount(res?.data?.total);
                    // setProfileMessage(true);
                    // if (res.data.statusCode === 404 && ) {
                    //     setProfileMessage(true);
                    // }
                },
                onError: (err) => {
                    setTransformedData([])
                    setCount(0)
                    console.error("API Error:", err);
                },
            })
    };

    React.useEffect(() => {
        // if (searchStatus)
        refetchListing()
    }, [searchStatus, page, limit, startup_id, reset, value])
    const [popupOpen, setPopupOpen] = React.useState(false);

    const Actions = () => {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const openMenu = Boolean(anchorEl);
        const handleClickMenu = (event, index) => {
            setAnchorEl(event.currentTarget);
            // setCurrentIndex(index)
            // console.log(event.currentTarget,"re")
        };
        const handleCloseMenu = (event) => {
            // console.log(event,"event")
            setAnchorEl(null);
            // setCurrentIndex(null);
        };
        return !inRound && <Box display={"flex"} justifyContent={"center"} gap={1} height={"100%"}>
            {/* {value === "invited" ? hasPermission("funding_rounds", "edit", userPermissions) && <B400 sx={{ height: 45, display: 'flex', marginLeft: 'auto', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: isMediumScreen ? 0 : '0.5rem', marginLeft: isMediumScreen ? 0 : '-0.25rem' } }} startIcon={<Add sx={{ width: 20, height: 20 }} />} onClick={() => handleInvitePopupOpen()}>{isMediumScreen ? "" : "Invite Investor"}</B400>
                : hasPermission("funding_rounds", "edit", userPermissions) && value === "interested" && <B400 sx={{ height: 45, display: 'flex', marginLeft: 'auto', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: isMediumScreen ? 0 : '0.5rem', marginLeft: isMediumScreen ? 0 : '-0.25rem' } }} startIcon={<RoundInvestmentIcon style={{ width: 20, height: 15, fill: !hasPermission("funding_rounds", "edit", userPermissions) ? "rgba(0, 0, 0, 0.26)" : 'white' }} />} onClick={() => setOpenAddInvestorModal(true)} >{isMediumScreen ? "" : "Add Investor"}</B400>} */}
            {/* <B400 startIcon={<RoundInvestmentIcon style={{ width: 20, height: 15, fill: 'white' }} />} onClick={() => {
                setPopupOpen(true);
            }} sx={{ display: 'flex', background: theme.palette.customColors.indigo700, padding: "0.625rem 1rem", "& > .MuiButton-icon.MuiButton-startIcon": { marginRight: isMediumScreen ? 0 : '0.5rem', marginLeft: isMediumScreen ? 0 : '-0.25rem' } }}>{isMediumScreen ? "" : "Add Investment"}</B400> */}
            {/* <Box> */}
            {/* {value === "interested" && transformedData?.length > 0 &&
                <Button sx={{ minWidth: "1rem" }} onClick={(e) => handleClickMenu(e)}>
                    <MoreOptionsIcon style={{ color: theme.palette.customColors.indigo700 }} />
                </Button>
            } */}
            {/* {value === "invited" && hasPermission("funding_rounds", "edit", userPermissions) &&
                <Button sx={{ minWidth: "1rem", marginBottom: '0.4rem' }} onClick={(e) => handleClickMenu(e)} disabled={!hasPermission("funding_rounds", "edit", userPermissions)}>
               
                    <MoreOptionsIcon style={{ color: theme.palette.customColors.indigo700 }} />
                </Button>
            } */}
            {/* <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                aria-controls={openMenu ? 'fade-menu' : 'fade-menu'}
                aria-haspopup="true"
                aria-expanded={openMenu ? 'true' : 'false'}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1,
                        padding: "12px",
                        borderRadius: "8px",
                        "& > ul.MuiList-root": { padding: "0 !important" },
                        bgcolor: theme.palette.customColors.g400,
                        color: theme.palette.customColors.whiteBG,
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 11,
                            width: 10,
                            height: 10,
                            bgcolor: theme.palette.customColors.g900,
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            > */}
            {/* {value === "invited" && <MenuItem disableRipple onClick={() => setOpenAddInvestorModal(true)} sx={{ borderBottom: `0px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                    <RoundInvestmentIcon style={{ width: 20, height: 15, fill: 'white', marginRight: '0.5rem' }} /> Add Investor
                </MenuItem>} */}
            {/* <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                    <Upload sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Import Investors
                </MenuItem> */}
            {/* {value === "invited" && transformedData?.length > 0 &&
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                        <GetAppOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Export Investors
                    </MenuItem>
                }
                {value === "interested" &&
                    <MenuItem disableRipple sx={{ borderBottom: `1px solid ${theme.palette.customColors.g700}`, padding: '0.625rem 1rem' }}>
                        <GetAppOutlined sx={{ width: 20, height: 20, marginRight: '0.5rem' }} /> Export Investors
                    </MenuItem>
                } */}
            {/* </Menu> */}
            {/* </Box> */}
        </Box>
    }

    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [openMoveInvestorPopup, setOpenMoveInvestorPopup] = useState(false);
    const [openMoveToInvestedPopup, setOpenMoveToInvestedPopup] = useState(false);
    const RowActions = ({ row }) => {

        const isSelected = currentRow?.investor_id === row?.original?.investor_id;
        // console.log(currentRow?.investor_id, row?.original)
        // code for Delete Popup
        const handleOpenDeletePopup = (row) => {
            setOpenDeletePopup(true);
            setCurrentRow(row);
        }
        const handleCloseDeletePopup = () => {
            setOpenDeletePopup(false);
            setCurrentRow(null);
        }

        // code for Moving investors from invited to interested

        const handleOpenMoveInvestorPopup = (row) => {
            setOpenMoveInvestorPopup(true);
            setCurrentRow(row);
        }
        const handleCloseMoveInvestorPopup = () => {
            setOpenMoveInvestorPopup(false);
            setCurrentRow(null);
        }
        const handleOpenMoveToInvestedPopup = (row) => {
            setOpenMoveToInvestedPopup(true);
            setCurrentRow(row);
        }
        const handleCloseMoveToInvestedPopup = () => {
            setOpenMoveToInvestedPopup(false);
            setCurrentRow(null);
        }

        const {
            mutateAsync: updateStatusAsync,
            isLoading: isMovingInvestor,
            status: updateStatusStatus,
            error: updateStatusError,
            data: updateStatusResponse
        } = ChangePipelineInvestorStatus({ round_id });
        // const {
        //     mutateAsync: moveToCapTableAsync,
        //     isLoading: isMovingToCapTable,
        //     status: moveToCapTableStatus,
        //     error: moveToCapTableError,
        //     data: moveToCapTableResponse
        // } = MovetoCapTable({ round_id });

        const handleMovetoInterested = async (currencyId, interestedAmount) => {
            if (currentRow?.pipeline_id) {
                try {
                    await updateStatusAsync({
                        payload: {
                            "status": "interested",
                            "currency_id": currencyId,
                            "interested_amount": Number(interestedAmount),
                            // "interested_shown_date": new Date().toISOString()
                        }
                        , pipeline_id: currentRow?.pipeline_id
                    }).then((succ) => {
                        addToast("Moved to Interested", "success")
                        refetchListing(); handleCloseMoveInvestorPopup();
                    });

                } catch (error) {
                    console.error("Error changing investor status:", error);
                }
            }
            else {
                addToast("ID not found", "error")
            }
        };

        const handleMoveToRejected = async () => {
            // console.log(currentRow, "currentRow")
            if (currentRow?.pipeline_id) {
                try {
                    await updateStatusAsync({
                        payload: {
                            "status": "rejected",
                            // "investor_rejected_date": new Date().toISOString()
                        }
                        , pipeline_id: currentRow?.pipeline_id
                    }).then((succ) => {
                        addToast("Moved to Rejected", "success")
                        refetchListing(); handleCloseDeletePopup();
                    });
                } catch (error) {
                    console.error("Error deleting investor:", error);
                }
            }
            else {
                addToast("ID not found", "error")
            }
        };


        // const handleMovetoInvested = async () => {
        // navigate(`/investors/add-investor`);
        // console.log(currentRow, "currentRow")
        // try {
        //     await updateStatusAsync({ payload: { investor_id: currentRow?.investor_id } }).then((succ) => { refetchListing(); handleCloseMoveInvestorPopup(); });

        // } catch (error) {
        //     console.error("Error deleting investor:", error);
        // }
        // };



        return <>
            {/* {
                isSelected && <DeleteConfirmationDialog open={openDeletePopup} handleClose={handleCloseDeletePopup} handleSubmission={handleMoveToRejected} heading={"Move to Rejected"} ActionText={"Confirm"} subheading={"Are you certain the investor is no longer interested in your startup? Moving this investor to 'Rejected' will indicate that they have decided not to proceed with the investment."} isLoading={isMovingInvestor} />
            }
            {
                isSelected && <InvestorMovePopup open={openMoveInvestorPopup} handleClose={handleCloseMoveInvestorPopup} handleSubmission={handleMovetoInterested} heading={"Move to Interested"} ActionText={"Confirm"} subheading={"Are you sure the investor has shown interest in your startup? Moving this investor to 'Interested' will indicate that they have expressed intent to invest."} isLoading={isMovingInvestor} hasFields={true} />
            } */}
            {/* {
                isSelected && <InvestorMovePopup open={openMoveToInvestedPopup} handleClose={handleCloseMoveToInvestedPopup} handleSubmission={handleMovetoInvested} heading={"Move to Invested"} ActionText={"Confirm"} subheading={"Are you sure this investor has already invested in your startup? Moving this investor to 'Invested' will officially reflect their commitment in your records."} isLoading={isMovingInvestor} />
            } */}
            <Box display={"flex"} gap={1}>
                {/* <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
            
                     <MailOutlineRounded sx={{ color: theme.palette.customColors.indigo700 }} />
                </Button> */}
                {(row?.original?.status === "invited") && <Tooltip title={"Move to Interested"}>
                    <Button sx={{ minWidth: "1rem" }} onClick={() => handleOpenMoveInvestorPopup(row?.original)} disabled={row?.original?.source === "Backrr"}>
                        {/* <MoreOptionsIcon /> */}
                        <Done sx={{ color: row?.original?.source === "Backrr" ? theme.palette.customColors.disabled : theme.palette.customColors.indigo700 }} />
                    </Button>
                </Tooltip>
                }
                {(row?.original?.status === "interested") && <Tooltip title={"Move to In-Progress"}>
                    <Button sx={{ minWidth: "1rem" }} onClick={() => handleMoveToInProgressOpen(row?.original)}>
                        {/* <MoreOptionsIcon /> */}
                        <DoneAll sx={{ color: theme.palette.customColors.indigo700 }} />
                    </Button>
                </Tooltip>
                }

                {/* {value !== "invited" &&
                    <>
                        <Tooltip title={"Kyc request, upload"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                               
                                <Update sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Documents"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                          
                                <DescriptionOutlined sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Call for money"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                              
                                <MailOutlined sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title={"Fund Received"}>
                            <Button sx={{ minWidth: "1rem" }} onClick={() => handleBankDetailsPopupOpen()}>
                             
                                <CallReceived sx={{ color: theme.palette.customColors.indigo700 }} />
                            </Button>
                        </Tooltip>
                    </>
                } */}

                {/* <Button sx={{ minWidth: "1rem" }} disabled={!hasPermission("funding_rounds", "edit", userPermissions)} onClick={() => { setOpenAddInvestorModal(true); setCurrentRow(row?.original) }} >
            
                    <EditOutlined sx={{ color: hasPermission("funding_rounds", "edit", userPermissions) ? theme.palette.customColors.indigo700 : 'inherit' }} />
                </Button> */}
                {(row?.original?.status === "in-progress") && <Tooltip title={"Edit"}>
                    <Button sx={{ minWidth: "1rem" }} onClick={() => {
                        setOpenMoveToInProgressModal(true);
                        setCurrentRow({ ...row?.original, ...row?.original?.pipeline, investor_name: row?.original?.name })
                    }}
                    // disabled={!hasPermission("funding_rounds", "edit", userPermissions)}
                    >
                        <EditOutlined sx={{
                            color:
                                // hasPermission("funding_rounds", "edit", userPermissions) ?
                                theme.palette.customColors.indigo700
                            //   : 'inherit'
                        }} />
                    </Button>
                </Tooltip>}
                {(row?.original?.status === "invited" || row?.original?.status === "interested" || row?.original?.status === "in-progress") && <Tooltip title={"Move to Rejected"}>
                    <Button sx={{ minWidth: "1rem" }} onClick={() => handleOpenDeletePopup(row?.original)}
                    // disabled={!hasPermission("funding_rounds", "edit", userPermissions)}
                    >
                        <Close sx={{
                            color:
                                //  hasPermission("funding_rounds", "edit", userPermissions) ?
                                theme.palette.customColors.indigo700
                            //   : 'inherit'
                        }} />
                    </Button>
                </Tooltip>}

            </Box>
        </>
    }


    const handleTabChange = (event, newValue) => {
        setCount(null);
        setPage(1);
        // console.log("value", newValue)
        setValue(newValue);
    };

    // const handleSwitch = () => {
    //     switch (value) {
    //         case 'invited':
    //             // <></>
    //             return <AllocateAmountPopup currency={currency} handleClose={() => handleBankDetailsPopupClose()} handleSubmit={handleSubmitBankDetails} />
    //         case 'interested':
    //             return <AllocateAmountPopup currency={currency} handleClose={() => handleBankDetailsPopupClose()} handleSubmit={handleSubmitBankDetails} />
    //         case 'invited':
    //             return <AllocateUnits currency={currency} handleClose={() => handleBankDetailsPopupClose()} handleSubmit={handleSubmitBankDetails} />
    //         default:
    //             return <></>
    //     }
    // }

    // const trans = transformedData?.filter(item => item.status === value) || []

    // console.log(trans, "trans")

    return (
        <>
            {/* <ModalComponent open={openInvitePopup} onClose={handleInvitePopupClose} style={{ maxWidth: 640, width: "100%" }}>
                <InviteInvestorPopup handleClose={handleInvitePopupClose} refetchListing={refetchListing} handleSubmit={handleInviteInvestor} />
            </ModalComponent>
            <ModalComponent open={openAddInvestorModal} onClose={handleAddInvestorClose} style={{ maxWidth: 640, width: "100%" }}>
                <AddInvestorPopup currency={currency} refetchListing={refetchListing} value={value} handleClose={handleAddInvestorClose} handleSubmit={handleAddInvestorSubmit} currentRow={currentRow} />
            </ModalComponent>
            <ModalComponent open={openMoveToInProgressModal} onClose={handleMoveToInProgressClose} style={{ maxWidth: 640, width: "100%" }}>
                <MoveToInProgressPopup currency={currency} refetchListing={refetchListing} value={value} handleClose={handleMoveToInProgressClose} handleSubmit={handleMoveToInProgressSubmit} currentRow={currentRow} />
            </ModalComponent> */}
            {/* <Dialog open={openBankDetailsPopup} onClose={() => { }}>
                <BankDetailsPopup handleClose={handleBankDetailsPopupClose} handleSubmit={handleSubmitBankDetails} />
            </Dialog> */}
            {/* <ModalComponent
                style={{ maxWidth: 640, width: "100%" }}
                //  sx={{ "& > .MuiDialog-container > .MuiPaper-root": { marginInline: 0 } }}
                open={openBankDetailsPopup} onClose={() => { handleBankDetailsPopupClose() }}>
                <Paper sx={{ maxHeight: '100%' }}>{handleSwitch()}</Paper>
            </ModalComponent> */}
            {/* <Dialog sx={{ "& > .MuiDialog-container > .MuiPaper-root": { marginInline: 0 } }} open={popupOpen} onClose={() => { setPopupOpen(false) }}>
                <AddInvestmentPopup currency={currency} handleClose={() => setPopupOpen(false)} handleSubmit={handleSubmitBankDetails} />
            </Dialog> */}
            {/* <ModalComponent open={openBankDetailsPopup} onClose={handleBankDetailsPopupClose} style={{ maxWidth: 640, width: "100%" }}>
                
            </ModalComponent> */}
            <TabContext value={value}>
                <Grid container xs={12} pt={1} pb={0} spacing={2} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
                    {/* <Grid item xs={10} lg={10}> */}
                    <Grid item xs={12} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} marginRight={"0rem"} >
                        <Grid xs={12} container sx={{ bgcolor: 'white', borderRadius: '8px 8px 0 0', borderInline: `1px solid ${theme.palette.customColors.b50}`, borderBlockStart: `1px solid ${theme.palette.customColors.b50}` }}>
                            <Grid item xs={10}>
                                <CustomTabs
                                    variant="submenu"
                                    titleStyle={{ fontSize: '1rem' }}
                                    tabStyle={{ padding: '0.5rem 1rem 0rem' }}
                                    sx={{ border: 'none' }}
                                    bgColor={"transparent"}
                                    data={
                                        [
                                            { value: "invited", label: value === "invited" ? `Invited${!isLoadingPipelineInvestors && count ? ` (${count})` : ""}` : "Invited", count: 10, read: false, icon: PublishedWithChanges, },
                                            { value: "interested", label: value === 'interested' ? `Interested${!isLoadingPipelineInvestors && count ? ` (${count})` : ""}` : "Interested", count: 10, read: false, icon: DoneRounded },
                                            { value: "in-progress", label: value === 'in-progress' ? `In-Progress${!isLoadingPipelineInvestors && count ? ` (${count})` : ""}` : "In-Progress", count: 10, read: false, icon: DoneAll },
                                            { value: "rejected", label: value === 'rejected' ? `Rejected${!isLoadingPipelineInvestors && count ? ` (${count})` : ""}` : "Rejected", count: 10, read: false, icon: Close },
                                        ]
                                    } value={value} handleChange={handleTabChange}
                                    isSmallScreen={isSmallScreen} className={classes.scrollTabs} key={"Tabs Tabs"} indicatorFullSize={false} />
                            </Grid>
                            <Grid item xs={2} pt={0.75} pr={1}>
                                <Actions />
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* { */}
                    {/* <Grid item xs={12} md={12} pt={"0 !important"} marginInline={"auto"} maxWidth={"100%"}> */}
                    {isLoadingPipelineInvestors ?
                        <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                            <Box className='skeleton' minHeight={"60dvh"} sx={{ borderRadius: "0 0 8px 8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

                            </Box>
                        </Grid>
                        : <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                            <AsyncTableListing
                                columns={columns}
                                // data={[]}
                                tabValue={value}
                                data={transformedData}
                                // title={"Investors"}
                                // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
                                // actions={Actions}
                                page={page}
                                setPage={setPage}
                                limit={limit}
                                setLimit={setLimit}
                                count={count}
                                // RowActions={RowActions}
                                noDataPlaceHolderImage={placeHolderImage}
                                noDataTitle={value === "invited" ? 'No Investors in Pipeline' : value === "interested" ? "No Investors in Interested" : value === "in-progress" ? "No Investors in In-Progress" : "No Investors in Rejected"}
                                noDataSubTitle='You do not have any investors.'
                                sx={{ borderRadius: '0 0 8px 8px', border: `1px solid ${theme.palette.customColors.b50}`, maxHeight: "calc(100dvh - 21.25rem)" }}
                                refetchListing={refetchListing}
                            />
                        </Box>
                    }

                    {/* </Grid>} */}
                    {/* <Grid item xs={2} lg={2}> */}

                </Grid>
            </TabContext>
        </>
    );
};

export default Pipelines;